import React, { Component, useEffect, useState } from 'react';
import { array, bool, func, number, object, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, intlShape, injectIntl } from '../../../util/reactIntl';
import { timestampToDate } from '../../../util/dates';
import { propTypes } from '../../../util/types';
import { BOOKING_PROCESS_NAME } from '../../../transactions/transaction';

import {
  Button,
  FieldLocationAutocompleteInput,
  FieldRadioButton,
  FieldSelect,
  Form,
  H4,
  H6,
  Modal,
  PrimaryButton,
} from '../../../components';
import {
  TagOutlined,
} from '@ant-design/icons';
import EstimatedCustomerBreakdownMaybe from '../EstimatedCustomerBreakdownMaybe';
import FieldDateAndTimeInput from './FieldDateAndTimeInput';

import css from './BookingTimeForm.module.css';
import {
  autocompletePlaceSelected,
  autocompleteSearchRequired,
  composeValidators,
  required,
} from '../../../util/validators';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { types } from 'sharetribe-flex-sdk';
import { formatMoney } from '../../../util/currency';
const { Money } = types;

const identity = v => v;

export class BookingTimeFormComponent extends Component {
  constructor(props) {
    super(props);
    this.minHours = this.props.listing?.attributes?.publicData?.numberOfHours || 1;

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.updateIsValid = this.updateIsValid.bind(this);
    this.applyDiscount = this.applyDiscount.bind(this);
    this.state = {
      isServiceError: true,
      isDiscountApplied: false,
      selectedPackage: [],
      discountValue: 0,
      discountType: '',
      selectedHours1: this.minHours,
      maxHours: '',
      isValid: false
    };
  }

  handleFormSubmit(e) {
    this.props.onSubmit(e);
  }

  getMaxHours(startDate) {
    const totalHoursInDay = 24;

    const startHours = startDate.getHours();
    const startMinutes = startDate.getMinutes();

    const remainingHours = totalHoursInDay - (startHours + (startMinutes > 0 ? 1 : 0));

    return remainingHours;
  }

  updateIsValid(value) {
    this.setState({
      isValid: value,
    });
  }

  // When the values of the form are updated we need to fetch
  // lineItems from this template's backend for the EstimatedTransactionMaybe
  // In case you add more fields to the form, make sure you add
  // the values here to the orderData object.
  handleOnChange(formValues) {
    const { bookingStartTime, bookingEndTime, slot, address, travelCharge, discountValue, discountType, selectedHours } = formValues.values;
    const startDate = bookingStartTime ? timestampToDate(bookingStartTime) : null;
    if (startDate) {
      const remainingHours = this.getMaxHours(startDate);
      this.setState({
        maxHours: remainingHours,
      });
    }
    const endDate = bookingEndTime ? timestampToDate(bookingEndTime) : null;

    const listingId = this.props?.listingId;
    const isOwnListing = this.props?.isOwnListing;
    const listingType = this.props?.listing?.attributes?.publicData?.listingType;
    const FixedLocation =
      this.props?.listing?.attributes?.publicData?.isFixedLocation === 'Yes' ||
      travelCharge === 'FixedLocation';
    const selectedPackage = this.state.selectedPackage;
    let providerDiscountValue = 0;
    let providerdiscountType = '';
    // Note: we expect values bookingStartTime and bookingEndTime to be strings
    // which is the default case when the value has been selected through the form
    const author = this.props.author;
    const discountDetails = author?.attributes?.profile?.publicData?.discountDetails;
    let isDiscountExpired;
    if (startDate && endDate) {
      const selectedStartDate = new Date(startDate.toDateString());
      const selectedEndDate = new Date(endDate.toDateString());
      const availableDiscountStartDate = new Date(discountDetails?.startDate).toDateString();
      const availableDiscountEndDate = new Date(discountDetails?.endDate).toDateString();

      isDiscountExpired = !(selectedStartDate >= new Date(availableDiscountStartDate) && selectedEndDate <= new Date(availableDiscountEndDate))
    }
    const isStartBeforeEnd = bookingStartTime < bookingEndTime;
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('startDate', startDate);
      localStorage.setItem('endDate', endDate);
      localStorage.setItem('address', JSON.stringify(address || ''));
      if (selectedPackage != [] && this.state.isDiscountApplied) {
        if (!isDiscountExpired) {
          providerDiscountValue = discountDetails.discountValue;
          providerdiscountType = discountDetails.discountType;
          this.setState({
            discountType: discountDetails.discountType,
            discountValue: discountDetails.discountValue
          });
          formValues.values.discountType = discountDetails.discountType;
          formValues.values.discountValue = discountDetails.discountValue;
        }
        else {
          this.setState({
            discountType: 0,
            discountValue: ''
          });
          formValues.values.discountType = '';
          formValues.values.discountValue = 0;
        }
      }
      else {
        providerDiscountValue = 0;
        providerdiscountType = '';
        formValues.values.discountType = '';
        formValues.values.discountValue = 0;
      }
    }

    if (travelCharge === 'FixedLocation') {
      formValues.values.address = '';
    }


    // this.setState({
    //   isDiscountApplied: false,
    // });

    if (!FixedLocation) {

      if (
        bookingStartTime &&
        bookingEndTime &&
        isStartBeforeEnd &&
        !this.props.fetchLineItemsInProgress &&
        address &&
        address?.selectedPlace != null &&
        selectedPackage.length != 0
      ) {
        this.props.onFetchTransactionLineItems({
          orderData: {
            bookingStart: startDate,
            bookingEnd: endDate,
            // slots: slot,
            address: address,
            selectedPackage: selectedPackage,
            selectedHours: this.state.selectedHours1,
            discountType: providerdiscountType,
            discountValue: providerDiscountValue
          },
          listingId,
          isOwnListing,
        });
      } else {

        if (
          bookingStartTime &&
          bookingEndTime &&
          isStartBeforeEnd &&
          !this.props.fetchLineItemsInProgress &&
          (selectedPackage.length != 0) &&
          address &&
          (address?.selectedPlace != null)
        ) {

          this.props.onFetchTransactionLineItems({
            orderData: {
              bookingStart: startDate,
              bookingEnd: endDate,
              slots: slot,
              address: address,
              selectedHours: this.state.selectedHours1,
              selectedPackage: selectedPackage,
              discountType: providerdiscountType,
              discountValue: providerDiscountValue
            },
            listingId,
            isOwnListing,
          });
        } else {



          if (address &&
            address?.selectedPlace != null) {
            this.props.onFetchTransactionLineItems({
              orderData: {
                bookingStart: startDate,
                bookingEnd: endDate,
                slots: slot,
                address: address,
                selectedPackage: selectedPackage,
                selectedHours: this.state.selectedHours1,
                discountType: providerdiscountType,
                discountValue: providerDiscountValue
              },
              listingId,
              isOwnListing,
            });
          } else {

            this.props.onFetchTransactionLineItems({
              orderData: {
                bookingStart: startDate,
                bookingEnd: endDate,
                slots: listingType !== 'hourly-service' ? slot : null,
                selectedPackage: selectedPackage,
                selectedHours: selectedHours,
                discountType: providerdiscountType,
                discountValue: providerDiscountValue
              },
              listingId,
              isOwnListing,
            });
          }
        }
      }
    } else {

      if (travelCharge === 'FixedLocation') {
        this.props.onFetchTransactionLineItems({
          orderData: {
            bookingStart: startDate,
            bookingEnd: endDate,
            slots: slot,
            address: '',
            selectedHours: this.state.selectedHours1,
            selectedPackage: selectedPackage,
            discountType: providerdiscountType,
            discountValue: providerDiscountValue
          },
          listingId,
          isOwnListing,
        });
      }
      else {

        if (address &&
          address?.selectedPlace != null) {
          this.props.onFetchTransactionLineItems({
            orderData: {
              bookingStart: startDate,
              bookingEnd: endDate,
              slots: slot,
              address: address,
              selectedHours: this.state.selectedHours1,
              selectedPackage: selectedPackage,
              discountType: providerdiscountType,
              discountValue: providerDiscountValue
            },
            listingId,
            isOwnListing,
          });
        } else {

          this.props.onFetchTransactionLineItems({
            orderData: {
              bookingStart: startDate,
              bookingEnd: endDate,
              slots: slot,
              selectedPackage: selectedPackage,
              selectedHours: this.state.selectedHours1,
              discountType: providerdiscountType,
              discountValue: providerDiscountValue
            },
            listingId,
            isOwnListing,
          });
        }
      }
    }
    if (
      bookingStartTime &&
      bookingEndTime &&
      isStartBeforeEnd &&
      !this.props.fetchLineItemsInProgress &&
      address &&
      address?.selectedPlace != null &&
      this.state.selectedHours1
    ) {

      this.props.onFetchTransactionLineItems({
        orderData: {
          bookingStart: startDate,
          bookingEnd: endDate,
          slots: slot,
          address: address,
          selectedHours: this.state.selectedHours1,
          selectedPackage: selectedPackage,
          discountType: providerdiscountType,
          discountValue: providerDiscountValue
        },
        listingId,
        isOwnListing,
      });
    }

    if (
      bookingStartTime &&
      bookingEndTime &&
      isStartBeforeEnd &&
      !this.props.fetchLineItemsInProgress &&
      this.state.selectedHours1 &&
      travelCharge === 'FixedLocation'

    ) {


      this.props.onFetchTransactionLineItems({
        orderData: {
          bookingStart: startDate,
          bookingEnd: endDate,
          slots: slot,
          address: '',
          selectedHours: this.state.selectedHours1,
          selectedPackage: selectedPackage,
          discountType: providerdiscountType,
          discountValue: providerDiscountValue
        },
        listingId,
        isOwnListing,
      });
    }
  }

  applyDiscount(values, discountValue, discountType) {
    const { bookingStartTime, bookingEndTime } = values;
    const startDate = bookingStartTime ? timestampToDate(bookingStartTime) : null;
    const endDate = bookingEndTime ? timestampToDate(bookingEndTime) : null;

    const listingId = this.props.listingId;
    const isOwnListing = this.props.isOwnListing;
    const selectedPackage = values?.selectedPackage;
    const address = values?.address;

    // Note: we expect values bookingStartTime and bookingEndTime to be strings
    // which is the default case when the value has been selected through the form
    const isStartBeforeEnd = bookingStartTime < bookingEndTime;
    this.setState({
      isDiscountApplied: true,
    });
    if (
      bookingStartTime &&
      bookingEndTime &&
      isStartBeforeEnd &&
      !this.props.fetchLineItemsInProgress
    ) {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('discountValue', discountValue);
        localStorage.setItem('discountType', discountType);
      }
      values.discountValue = discountValue;
      values.discountType = discountType;

      this.props.onFetchTransactionLineItems({
        orderData: {
          bookingStart: startDate,
          bookingEnd: endDate,
          slots: values.slot,
          discountValue: discountValue,
          discountType: discountType,
          selectedHours: this.state.selectedHours1,
          address: address,
          selectedPackage: selectedPackage,
        },
        listingId,
        isOwnListing,
      });
    }
  }

  handleErrorChange = value => {
    this.setState({ isServiceError: value });
  };

  render() {
    const {
      rootClassName,
      className,
      price: unitPrice,
      dayCountAvailableForBooking,
      marketplaceName,
      ...rest
    } = this.props;
    const classes = classNames(rootClassName || css.root, className);
    return (
      <FinalForm
        {...rest}
        unitPrice={unitPrice}
        onSubmit={this.handleFormSubmit}
        render={fieldRenderProps => {
          const {
            endDatePlaceholder,
            startDatePlaceholder,
            form,
            pristine,
            handleSubmit,
            intl,
            isOwnListing,
            listingId,
            values,
            monthlyTimeSlots,
            onFetchTimeSlots,
            timeZone,
            lineItems,
            fetchLineItemsInProgress,
            fetchLineItemsError,
            payoutDetailsWarning,
            listing,
            commissions,
            isModifyTime,
            transaction,
            onFetchTransactionLineItems,
            author,
            isProvider,
            setErrorModalOpen,
            iserrorModal
          } = fieldRenderProps;

          const [distance, setDistance] = useState('');
          const [open, setOpen] = useState(false);
          const [selectedInfo, setSelectedInfo] = useState([]);
          const [container, setContainer] = useState(null);
          let packageBook = true;
          if (lineItems?.map(item => item?.code)?.some(x => x?.startsWith('line-item/package'))) {
            packageBook = false;
          }

          if (this.state.selectedPackage) {
            values.selectedPackage = this.state.selectedPackage;
          }

          const minHours = parseFloat(fieldRenderProps?.listing?.attributes?.publicData?.numberOfHours) || 1;
          const [hours, setHours] = useState(minHours);

          useEffect(() => {
            values.selectedHours = hours;
            this.props.onFetchTransactionLineItems({
              orderData: {
                bookingStart: startDate,
                bookingEnd: endDate,
                selectedHours: values.selectedHours,
                discountValue: this.state.isDiscountApplied ? discountValue : '',
                discountType: this.state.isDiscountApplied ? discountType : '',
                address: values?.address,
                slots: values?.slot
              },
              listingId,
              isOwnListing,

            });
          }, [hours]);

          useEffect(() => {
            setHours(minHours);
            this.props.onFetchTransactionLineItems({
              orderData: {
                bookingStart: startDate,
                bookingEnd: endDate,
                slots: listingType !== 'hourly-service' ? values?.slot : null,
                address: values?.address,
                selectedPackage: this.state.selectedPackage,
                selectedHours: listingType == 'hourly-service' ? minHours : null,
                discountValue: this.state.isDiscountApplied ? discountValue : '',
                discountType: this.state.isDiscountApplied ? discountType : '',
              },
              listingId,
              isOwnListing,
            });
          }, [values.bookingStartTime]);


          const startTime = values && values.bookingStartTime ? values.bookingStartTime : null;
          const endTime = values && values.bookingEndTime ? values.bookingEndTime : null;
          const startDate = startTime ? timestampToDate(startTime) : null;
          const endDate = endTime ? timestampToDate(endTime) : null;
          const duration = fieldRenderProps?.listing?.attributes?.publicData?.duration;
          const listingType = listing?.attributes?.publicData?.listingType;
          const fixedLocationService = listing?.attributes?.publicData?.isFixedLocation;
          const maximumDistance = listing?.attributes?.publicData?.maximumDistance;
          const publicData = listing?.attributes?.publicData;
          // Check if discountDetails exists
          const discountDetails = this.props?.listing?.attributes?.publicData?.discountDetails;
          let isDiscountExpired;
          if (startDate && endDate) {
            const selectedStartDate = new Date(values?.bookingStartDate?.date);
            const selectedEndDate = new Date(values?.bookingEndDate?.date);
            const availableDiscountStartDate = new Date(discountDetails?.startDate);
            const availableDiscountEndDate = new Date(discountDetails?.endDate);
            isDiscountExpired = !(selectedStartDate >= new Date(availableDiscountStartDate) && selectedEndDate <= new Date(availableDiscountEndDate))
          }

          const serviceAddress = listing?.attributes?.publicData?.location?.address;
          const addressRequiredMessage = intl.formatMessage({
            id: 'BookingTimeForm.addressRequired',
          });
          const addressNotRecognizedMessage = intl.formatMessage({
            id: 'EditListingLocationForm.addressNotRecognized',
          });

          const toggleSelection = item => {
            publicData?.serviceSection?.forEach(serviceItem => {
              if (serviceItem.serviceName === item.serviceName) {
                if (serviceItem.quantity > 0) {
                  serviceItem.quantity = 0;
                  item.validationError = null;
                } else {
                  serviceItem.quantity = serviceItem.serviceMinQuantity || 1;
                }
              }
            });

            const selected = publicData?.serviceSection.filter(item => item.quantity > 0);
            this.setState({ selectedPackage: selected });

            let startDate, endDate, address, providerDiscountValue, providerdiscountType;
            if (typeof localStorage !== 'undefined') {
              startDate = localStorage?.getItem('startDate');
              endDate = localStorage?.getItem('endDate');
              address = JSON.parse(localStorage?.getItem('address'));
              if (!isDiscountExpired && this.state.isDiscountApplied) {
                providerDiscountValue = discountDetails.discountValue;
                providerdiscountType = discountDetails.discountType;
              }
              else {
                providerDiscountValue = 0;
                providerdiscountType = '';
                values.discountType = '';
                values.discountValue = 0;
              }
            }

            onFetchTransactionLineItems({
              orderData: {
                bookingStart: startDate,
                bookingEnd: endDate,
                address: address || '',
                selectedPackage: selected,
                selectedHours: this.state.selectedHours1,
                discountType: providerdiscountType,
                discountValue: providerDiscountValue
              },
              listingId,
              isOwnListing,
            });
          };

          const onSelectNoOfItems = (quantity, selectedItem) => {
            publicData?.serviceSection.forEach(item => {
              if (item.serviceName === selectedItem.serviceName) {
                const minQuantity = item.serviceMinQuantity || 1;

                if (quantity === '') {
                  item.quantity = 0;
                  item.validationError = null;
                  setErrorMessage("");
                } else if (quantity < minQuantity) {
                  setErrorMessage("This service requires a minimum booking of " + minQuantity + " packages");
                  // setErrorModalOpen(true);
                  // item.validationError = `Minimum quantity for this package is ${minQuantity}`;
                  item.quantity = minQuantity;

                } else {
                  item.validationError = null;
                  item.quantity = quantity;
                  setErrorMessage("");
                }
              }
            });

            const selected = publicData?.serviceSection.filter(item => item.quantity > 0);
            this.setState({
              selectedPackage: selected,
            });

            let startDate, endDate, address, providerDiscountValue, providerdiscountType;

            if (typeof localStorage !== 'undefined') {
              startDate = localStorage?.getItem('startDate');
              endDate = localStorage?.getItem('endDate');
              address = JSON.parse(localStorage?.getItem('address'));
              if (!isDiscountExpired && this.state.isDiscountApplied) {
                providerDiscountValue = discountDetails.discountValue;
                providerdiscountType = discountDetails.discountType;
              }
              else {
                providerDiscountValue = 0;
                providerdiscountType = '';
                values.discountType = '';
                values.discountValue = 0;
              }
            }

            this.setState({
              discountValue: providerDiscountValue,
              discountType: providerdiscountType,
            });
            onFetchTransactionLineItems({
              orderData: {
                bookingStart: startDate,
                bookingEnd: endDate,
                address: address || '',
                selectedPackage: selected,
                selectedHours: this.state.selectedHours1,
                discountType: providerdiscountType,
                discountValue: providerDiscountValue
              },
              listingId,
              isOwnListing,
            });
          };

          const handleClickOpen = (index) => {
            if (index?.show == 'serviceName') {
              setSelectedInfo(index?.item?.serviceName);
            } else {
              setSelectedInfo(index?.item?.serviceDescription);
            }
            setOpen(true);
          };
          const handleClose = () => {
            setOpen(false);
          };
          const colors = 'var(--marketplaceColor)';

          // This is the place to collect breakdown estimation data. See the
          // EstimatedCustomerBreakdownMaybe component to change the calculations
          // for customized payment processes.
          const breakdownData =
            startDate && endDate
              ? {
                startDate,
                endDate,
              }
              : null;

          let showEstimatedBreakdown =
            breakdownData && lineItems && !fetchLineItemsInProgress && !fetchLineItemsError;

          if (listingType == 'package') {
            showEstimatedBreakdown =
              breakdownData && lineItems && !fetchLineItemsInProgress && !fetchLineItemsError && this.state.selectedPackage?.length != 0;
          }
          const [isDiscountAvailable, setDiscountAvailable] = useState(false);
          let discountValue;
          let discountType;
          if (discountDetails) {
            const currentDate = new Date();

            const isWithinDiscountPeriod = (start, end) =>
              new Date(start) >= new Date(discountDetails.startDate) &&
              new Date(end) <= new Date(discountDetails.endDate);

            const isServiceAvailable = () =>
              new Date(currentDate) >= new Date(discountDetails.serviceStartDate) &&
              new Date(currentDate) <= new Date(discountDetails.serviceEndDate);

            if (isWithinDiscountPeriod(startDate, endDate) && isServiceAvailable()) {
              discountValue = discountDetails.discountValue;
              discountType = discountDetails.discountType;

              if (!isDiscountAvailable) {
                setDiscountAvailable(true);
              }
            }
          }

          const transportationFeeMaybe = fixedLocationService ?
            (fixedLocationService === 'Both' ? (
              <>
                <div className={css.radioButtons}>
                  <FieldSelect
                    id="travelCharge"
                    name="travelCharge"
                    label={'Service Location'}
                    validate={required(intl.formatMessage({ id: 'BookingDatesForm.locationRequired' }))}
                  >
                    <option disabled value="">
                      {intl.formatMessage({ id: 'BookingTimeForm.serviceLocation' })}
                    </option>
                    <option value="variableLocation">
                      {intl.formatMessage({ id: 'BookingTimeForm.customerLocation' })}
                    </option>
                    <option value="FixedLocation">
                      {intl.formatMessage({ id: 'BookingTimeForm.providerLocation' })}
                    </option>
                  </FieldSelect>
                </div>
                {values.travelCharge === 'variableLocation' && (
                  <>
                    <FieldLocationAutocompleteInput
                      rootClassName={css.locationAddressYourLocation}
                      inputClassName={css.locationAutocompleteInput}
                      iconClassName={css.locationAutocompleteInputIcon}
                      predictionsClassName={css.predictionsRoot}
                      validClassName={css.validLocation}
                      name="address"
                      id="address"
                      label={intl.formatMessage({ id: 'BookingTimeForm..address' })}
                      placeholder={intl.formatMessage({
                        id: 'BookingTimeForm..addressPlaceholder',
                      })}
                      useDefaultPredictions={false}
                      format={identity}
                      validate={composeValidators(
                        autocompleteSearchRequired(addressRequiredMessage),
                        autocompletePlaceSelected(addressNotRecognizedMessage)
                      )}
                    />
                  </>
                )}
              </>
            ) : fixedLocationService === 'No' ? (
              <>

                <FieldLocationAutocompleteInput
                  rootClassName={css.locationAddress}
                  inputClassName={css.locationAutocompleteInput}
                  iconClassName={css.locationAutocompleteInputIcon}
                  predictionsClassName={css.predictionsRoot}
                  validClassName={css.validLocation}
                  name="address"
                  id="address"
                  label="Enter your address"
                  placeholder={intl.formatMessage({ id: 'BookingTimeForm..addressPlaceholder' })}
                  useDefaultPredictions={false}
                  validate={composeValidators(
                    autocompleteSearchRequired(addressRequiredMessage),
                    autocompletePlaceSelected(addressNotRecognizedMessage)
                  )}
                />
                <p className={css.extraInfoLocation}>This service is provided at customer location only</p>
              </>
            ) : (
              <>
                <p className={css.serviceProviderReadyTime} style={{ fontSize: '14px', color: 'grey', marginTop: '-28px' }}>{intl.formatMessage({ id: 'BookingTimeForm.providerLocationMessage' })}</p>
              </>
            )) : null;




          const setTravelDistance = () => {
            setDistance(distance);
          };
          const [selectedSlots, setSelectedSlots] = useState(1);
          const [errorMessage, setErrorMessage] = useState('');
          // const [iserrorModal, setErrorModalOpen] = useState(false);

          const handleSlotIncrement = () => {
            const slots = selectedSlots + 1;
            setSelectedSlots(slots);
            values.slot = slots;
            setErrorMessage('');
            this.props.onFetchTransactionLineItems({
              orderData: {
                bookingStart: startDate,
                bookingEnd: endDate,
                address: values?.address,
                // discountValue: discountValue,
                // discountType: discountType,
                discountValue: this.state.isDiscountApplied ? discountValue : '',
                discountType: this.state.isDiscountApplied ? discountType : '',
                slots: values.slot,
              },
              listingId,
              isOwnListing,
            });
          };

          const handleSlotDecrement = () => {
            if (selectedSlots > 1) {
              const slots = selectedSlots - 1;
              setSelectedSlots(slots);
              values.slot = slots;
              setErrorMessage('');

              this.props.onFetchTransactionLineItems({
                orderData: {
                  bookingStart: startDate,
                  bookingEnd: endDate,
                  address: values?.address,
                  // selectedHours:this.state.selectedHours1,
                  discountValue: this.state.isDiscountApplied ? discountValue : '',
                  discountType: this.state.isDiscountApplied ? discountType : '',
                  // discountValue: discountValue,
                  // discountType: discountType,
                  slots: values.slot,
                },
                listingId,
                isOwnListing,
              });
            }
            else {
              setErrorMessage('This service\'s minimum services is 1!!');
              // setErrorModalOpen(true);
            }
          };

          const handleIncrement = () => {
            if (hours < this.state.maxHours) {
              const selectedHours = hours + 1;
              setHours(selectedHours);
              setErrorMessage('');
              this.setState({
                selectedHours1: selectedHours,
              });


              this.props.onFetchTransactionLineItems({
                orderData: {
                  bookingStart: startDate,
                  bookingEnd: endDate,
                  address: values?.address,
                  // discountValue: discountValue,
                  // discountType: discountType,
                  discountValue: this.state.isDiscountApplied ? discountValue : '',
                  discountType: this.state.isDiscountApplied ? discountType : '',
                  selectedHours: selectedHours,
                },
                listingId,
                isOwnListing,
              });
            }
          };
          const handleDecrement = () => {
            if (hours > minHours) {
              const selectedHours = hours - 1;
              setHours(selectedHours);
              this.setState({
                selectedHours1: selectedHours,
              });
              setErrorMessage('');

              this.props.onFetchTransactionLineItems({
                orderData: {
                  bookingStart: startDate,
                  bookingEnd: endDate,
                  address: values?.address,
                  discountValue: this.state.isDiscountApplied ? discountValue : '',
                  discountType: this.state.isDiscountApplied ? discountType : '',
                  // discountValue: discountValue,
                  // discountType: discountType,
                  selectedHours: selectedHours,
                },
                listingId,
                isOwnListing,
              });
            }
            else {
              let error = <span>This service requires a minimum booking of {minHours} {parseInt(minHours) == 1 ? 'hour' : 'hours'}</span>
              setErrorMessage(error);
              //setErrorModalOpen(true);
            }
          };

          if (isModifyTime) {

            let disable = !fieldRenderProps?.modified?.bookingStartTime || !(this.state.isValid);
            if (listingType == 'duration') {
              disable = !fieldRenderProps?.modified?.bookingStartTime || !values.bookingEndTime || !(this.state.isValid);
            }



            return (
              <Form
                onSubmit={handleSubmit}
                className={classes}
                enforcePagePreloadFor="CheckoutPage"
              >
                <FormSpy
                  subscription={{ values: true }}
                  onChange={values => {
                    this.handleOnChange(values);
                  }}
                />
                {monthlyTimeSlots && timeZone ? (
                  <FieldDateAndTimeInput
                    startDateInputProps={{
                      label: intl.formatMessage({ id: 'BookingTimeForm.bookingStartTitle' }),
                      placeholderText: startDatePlaceholder,
                    }}
                    endDateInputProps={{
                      label: intl.formatMessage({ id: 'BookingTimeForm.bookingEndTitle' }),
                      placeholderText: endDatePlaceholder,
                    }}
                    className={css.bookingDates}
                    listingId={listingId}
                    onFetchTimeSlots={onFetchTimeSlots}
                    monthlyTimeSlots={monthlyTimeSlots}
                    values={values}
                    intl={intl}
                    form={form}
                    pristine={pristine}
                    timeZone={timeZone}
                    dayCountAvailableForBooking={dayCountAvailableForBooking}
                    duration={duration}
                    listingType={listingType}
                    handleErrorChange={this.handleErrorChange}
                    fetchLineItemsInProgress={fetchLineItemsInProgress}
                    isModifyTime={isModifyTime}
                    transaction={transaction}
                    updateIsValid={this.updateIsValid}
                    previousValidState={this.state.isValid}
                  />
                ) : null}

                {fetchLineItemsError ? (
                  <span className={css.sideBarError}>
                    <FormattedMessage id="BookingTimeForm.fetchLineItemsError" />
                  </span>
                ) : null}

                {!this.state.isValid ? <span style={{ color: 'red' }}>Time slot booked. Choose another.</span> : null}
                <div className={css.submitButton}>
                  <PrimaryButton
                    type="submit"
                    inProgress={fetchLineItemsInProgress}
                    disabled={isModifyTime ? disable : this.state.isServiceError}
                  >
                    {isModifyTime ? (
                      'Send request for modified time'
                    ) : (
                      <FormattedMessage id="BookingTimeForm.requestToBook" />
                    )}
                  </PrimaryButton>

                  {isProvider ?
                    <div>
                      <p className={css.modifyNote}>
                        Please make sure to select a suitable time based on your availability.
                      </p>
                    </div>
                    : null}
                </div>
              </Form>
            );
          }

          let isDisabled = true;
          const location = this.props?.listing?.attributes?.publicData?.isFixedLocation || 'Yes';
          const FixedLocation = (location === 'Yes' || location === 'Both');

          const hasRequiredValues = (listingType === 'package')
            ? (FixedLocation ? this.state.selectedPackage.length !== 0 : (values.address && this.state.selectedPackage.length !== 0))
            : (listingType === 'duration' ? (values.slot ? values.slot : 1) && true : true);

          const travelCharges = (location === 'Both')
            ? (values?.travelCharge === "FixedLocation" ? true :
              (values?.travelCharge === "variableLocation" || values?.travelCharge === undefined) ? false : true)
            : true;

          let isDisableDiscount = false;
          if (values?.bookingStartDate) {
            const startDate = new Date(values?.bookingStartDate?.date);
            const endDate = new Date(values?.bookingEndDate?.date);
            const discountStartDate = new Date(discountDetails?.startDate);
            const discountEndDate = new Date(discountDetails?.endDate);
            if (startDate && endDate && new Date(startDate) >= new Date(discountStartDate) && new Date(endDate) < new Date(discountEndDate)) {
              isDisableDiscount = true;
            }
            else {
              isDisableDiscount = false;
            }
          }

          if (isDisableDiscount) {
            isDisabled = !(values.bookingStartDate &&
              (FixedLocation ? hasRequiredValues : hasRequiredValues && values.address?.selectedPlace) &&
              (travelCharges ? travelCharges : hasRequiredValues && values.address?.selectedPlace));
          }

          return (
            <Form onSubmit={handleSubmit} className={classes} enforcePagePreloadFor="CheckoutPage">
              <FormSpy
                subscription={{ values: true }}
                onChange={values => {
                  this.handleOnChange(values);
                }}
              />

              {monthlyTimeSlots && timeZone ? (
                <FieldDateAndTimeInput
                  startDateInputProps={{
                    label: intl.formatMessage({ id: 'BookingTimeForm.bookingStartTitle' }),
                    placeholderText: startDatePlaceholder,
                  }}
                  endDateInputProps={{
                    label: intl.formatMessage({ id: 'BookingTimeForm.bookingEndTitle' }),
                    placeholderText: endDatePlaceholder,
                  }}
                  className={css.bookingDates}
                  listingId={listingId}
                  onFetchTimeSlots={onFetchTimeSlots}
                  monthlyTimeSlots={monthlyTimeSlots}
                  values={values}
                  intl={intl}
                  form={form}
                  pristine={pristine}
                  timeZone={timeZone}
                  dayCountAvailableForBooking={dayCountAvailableForBooking}
                  duration={duration}
                  listingType={listingType}
                  handleErrorChange={this.handleErrorChange}
                  fetchLineItemsInProgress={fetchLineItemsInProgress}
                  handleDecrement={handleDecrement}
                  handleIncrement={handleIncrement}
                  hours={hours}
                  handleSlotIncrement={handleSlotIncrement}
                  handleSlotDecrement={handleSlotDecrement}
                  selectedSlots={selectedSlots}
                  errorMessage={errorMessage}
                  minHours={this.minHours}
                />
              ) : null}
              {/* {listingType === 'hourly-service'?
              <>
               <div className={css.adjustContainerLabel}>No of hours</div>
                <div className={css.numberAdjusterContainer}>                
                <button 
                    type="button" 
                    className={css.adjustButton} 
                    onClick={handleDecrement}
                  >-
                  </button>          
        
                  <input
                    className={css.adjustInput}
                    type="text"
                    value={hours}
                    readOnly        
                  />             
                    
                  <button 
                    type="button" 
                    className={css.adjustButton} 
                    onClick={handleIncrement}
                  >+
                  </button>
                  <br></br>
                </div>
                </>
               
              :null} */}
              <Modal
                isOpen={iserrorModal}
                onClose={() => {
                  setErrorModalOpen(false);
                }}
                onManageDisableScrolling={console.log}
              >
                <p>{errorMessage}</p>

              </Modal>
              <div className={css.timeErrorMsg}>
                {errorMessage}
              </div>
              {transportationFeeMaybe}
              {(values.travelCharge == 'FixedLocation' || fixedLocationService === 'Yes') && (
                <div>
                  <p className={css.serviceProvideradrdess} style={{ fontSize: '16px', fontWeight: '600', marginTop: '-10px', marginBottom: '6px' }}> Service Provider’s Address </p>
                  <p className={css.serviceProvideradrdess} style={{ fontSize: '16px', marginBottom: '20px', marginTop: '0px' }}>  {serviceAddress} </p>
                </div>
              )}
              {/* {distance}--{maximumDistance} */}
              {values?.travelCharge !== "FixedLocation" && distance !== '' && parseFloat(distance) > parseFloat(maximumDistance) && values.address !== '' ? (
                <div className={css.distanceMessage}>

                  <FormattedMessage
                    id="BookingTimeForm.beyondDistanceMessage"
                    values={{
                      authorDisplayName: listing?.author?.attributes?.profile?.displayName,
                      distance: distance,
                      maxDistance: listing?.attributes?.publicData?.maximumDistance
                    }}
                  />

                </div>
              ) : null}

              {listingType == 'package' ? (
                <>
                  <div className={css.radioButtons}>
                    <label className={css.selectPck}>
                      <FormattedMessage id="ListingPage.selectPackage" />
                    </label>
                    <div className={css.wrapper}>
                      {publicData?.serviceSection &&
                        publicData.serviceSection.length > 0 &&
                        (publicData.serviceSection.length > 2 ? (
                          <div id="imageContainer" className={css.imageContainer}>
                            {publicData.serviceSection.map((item, idx) => {
                              let displayPrice = item.servicePrice;
                              const validationError = item.validationError;
                              const minQuantity = item.serviceMinQuantity || 1;
                              const isSelected = item.quantity > 0;

                              if (!isOwnListing && commissions) {
                                displayPrice =
                                  item.servicePrice +
                                  (item.servicePrice * commissions?.customerCommission?.percentage) /
                                  100;
                              }

                              return (
                                <div
                                  key={`package-${idx}`}
                                  className={`${css.accessorySection} ${isSelected ? css.selected : ''
                                    }`}
                                  onClick={() => toggleSelection(item)}
                                >
                                  <div className={css.accessoryBox}>
                                    <div className={css.customNumberHeading}>
                                      {item.serviceDescription && (
                                        <Tooltip
                                          title={
                                            <React.Fragment>
                                              <div
                                                className={css.infoText}
                                              //onClick={() => handleClickOpen({item, show: 'serviceDescription'})}
                                              >
                                                {item.serviceDescription}
                                              </div>
                                            </React.Fragment>
                                          }
                                          placement="bottom"
                                          color={colors}
                                          key={colors}
                                          arrow={true}
                                        >
                                          <div className={css.infoIconTooltip}>
                                            <InfoCircleOutlined />
                                          </div>
                                        </Tooltip>
                                      )}

                                      {item.serviceName.length > 12 ?
                                        <Tooltip title={<React.Fragment>
                                          <div
                                            className={css.infoText}
                                            onClick={() => handleClickOpen({ item, show: 'serviceName' })}
                                          >
                                            {item.serviceName}
                                          </div>
                                        </React.Fragment>} placement="top" arrow={true} color={colors} >
                                          <h2 className={css.accessoryName}>
                                            {`${item.serviceName.substring(0, 12)}...`}
                                          </h2>
                                        </Tooltip>
                                        :
                                        <h2 className={css.accessoryName}>
                                          {item.serviceName}
                                        </h2>}

                                    </div>
                                    <div className={css.customNumberContainer}>
                                      <p className={css.accessoryPrice}>
                                        {formatMoney(intl, new Money(displayPrice || 0, 'AUD'))}
                                      </p>

                                      <div className={css.customNumberInput}>
                                        <button
                                          type="button"
                                          className={css.customButton}
                                          onClick={e => {
                                            e.stopPropagation();
                                            const currentQuantity = Number(
                                              item.quantity || minQuantity
                                            );
                                            const newQuantity = currentQuantity - 1;
                                            onSelectNoOfItems(newQuantity, item);
                                          }}
                                          disabled={item.quantity < minQuantity}
                                        >
                                          &#8722;
                                        </button>

                                        <input
                                          type="text"
                                          name="noOfItems"
                                          id={`package-${idx}`}
                                          step="1"
                                          placeholder={isSelected ? minQuantity.toString() : ''}
                                          value={item.quantity || minQuantity}
                                          disabled={!isSelected}
                                          onClick={e => e.stopPropagation()}
                                          className={css.packageCount}
                                          // onChange={e => {
                                          //   const quantity = e.currentTarget.value;
                                          //   if (quantity === '') {
                                          //     onSelectNoOfItems('', item);
                                          //   } else {
                                          //     
                                          //     const quantityNumber = Number(quantity);
                                          //     onSelectNoOfItems(quantityNumber, item);
                                          //   }
                                          // }}
                                          onBlur={e => {
                                            const quantity = e.currentTarget.value
                                              ? Number(e.currentTarget.value)
                                              : '';
                                            if (quantity < minQuantity) {
                                              onSelectNoOfItems(minQuantity, item);
                                            }
                                          }}
                                        />

                                        <button
                                          type="button"
                                          className={css.customButton}
                                          onClick={e => {
                                            e.stopPropagation();
                                            const currentQuantity = Number(
                                              item.quantity || minQuantity
                                            );
                                            const newQuantity = currentQuantity + 1;
                                            onSelectNoOfItems(newQuantity, item);
                                          }}
                                        >
                                          &#43;
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  {validationError && (
                                    <p
                                      style={{
                                        color: 'red',
                                        textAlign: 'center',
                                        margin: '0',
                                        fontSize: '12px',
                                      }}
                                    >
                                      {validationError}
                                    </p>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <div id="imageContainer" className={css.imageContainer}>
                            {publicData.serviceSection.map((item, idx) => {
                              let displayPrice = item.servicePrice;
                              const validationError = item.validationError;
                              const minQuantity = item.serviceMinQuantity || 1;
                              const isSelected = item.quantity > 0;

                              if (!isOwnListing && commissions) {
                                displayPrice =
                                  item.servicePrice +
                                  (item.servicePrice * commissions?.customerCommission?.percentage) /
                                  100;
                              }

                              return (
                                <div
                                  key={`package-${idx}`}
                                  className={`${css.accessorySection} ${isSelected ? css.selected : ''
                                    }`}
                                  onClick={() => toggleSelection(item)}
                                >
                                  <div className={css.accessoryBox}>

                                    <div className={css.customNumberHeading}>
                                      {item.serviceDescription && (
                                        <Tooltip
                                          title={
                                            <React.Fragment>
                                              <div
                                                className={css.infoText}
                                              //onClick={() => handleClickOpen({item, show : 'serviceDescription'})}
                                              >
                                                {item.serviceDescription}
                                              </div>
                                            </React.Fragment>
                                          }
                                          placement="bottom"
                                          color={colors}
                                          key={colors}
                                          arrow={true}
                                        >
                                          <div className={css.infoIconTooltip}>
                                            <InfoCircleOutlined />
                                          </div>
                                        </Tooltip>
                                      )}

                                      {item.serviceName.length > 12 ?
                                        <Tooltip title={<React.Fragment>
                                          <div
                                            className={css.infoText}
                                            onClick={() => handleClickOpen({ item, show: 'serviceName' })}
                                          >
                                            {item.serviceName}
                                          </div>
                                        </React.Fragment>} placement="top" arrow={true} color={colors}>
                                          <h2 className={css.accessoryName}>
                                            {`${item.serviceName.substring(0, 12)}...`}
                                          </h2>
                                        </Tooltip>
                                        :
                                        <h2 className={css.accessoryName}>
                                          {item.serviceName}
                                        </h2>}

                                    </div>
                                    <div className={css.customNumberContainer}>
                                      <p className={css.accessoryPrice}>
                                        {formatMoney(intl, new Money(displayPrice || 0, 'AUD'))}
                                      </p>

                                      <div className={css.customNumberInput}>
                                        <button
                                          type="button"
                                          className={css.customButton}
                                          onClick={e => {
                                            e.stopPropagation();
                                            const currentQuantity = Number(
                                              item.quantity || minQuantity
                                            );
                                            const newQuantity = Math.max(
                                              currentQuantity - 1,
                                              minQuantity
                                            );
                                            onSelectNoOfItems(currentQuantity - 1, item);
                                          }}
                                        // disabled={item.quantity <= minQuantity}
                                        >
                                          &#8722;
                                        </button>

                                        <input
                                          type="text"
                                          name="noOfItems"
                                          id={`package-${idx}`}
                                          step="1"
                                          placeholder={isSelected ? minQuantity.toString() : ''}
                                          value={item.quantity || minQuantity}
                                          className={css.packageCount}
                                          disabled={!isSelected}
                                          onClick={e => e.stopPropagation()}
                                          onChange={e => {
                                            const quantity = e.currentTarget.value;
                                            if (quantity === '') {
                                              onSelectNoOfItems('', item);
                                            } else {
                                              const quantityNumber = Number(quantity);
                                              onSelectNoOfItems(quantityNumber, item);
                                            }
                                          }}
                                          onBlur={e => {
                                            const quantity = e.currentTarget.value
                                              ? Number(e.currentTarget.value)
                                              : '';
                                            if (quantity < minQuantity) {
                                              onSelectNoOfItems(minQuantity, item);
                                            }
                                          }}
                                        />

                                        <button
                                          type="button"
                                          className={css.customButton}
                                          onClick={e => {
                                            e.stopPropagation();
                                            const currentQuantity = Number(
                                              item.quantity || minQuantity
                                            );
                                            const newQuantity = currentQuantity + 1;
                                            onSelectNoOfItems(newQuantity, item);
                                          }}
                                        >
                                          &#43;
                                        </button>
                                      </div>
                                    </div>

                                  </div>
                                  {validationError && (
                                    <p
                                      style={{
                                        color: 'red',
                                        textAlign: 'center',
                                        margin: '0',
                                        fontSize: '12px',
                                      }}
                                    >
                                      {validationError}
                                    </p>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ))}

                      {open && (
                        <div className={css.dialogoverlay} onClick={handleClose}>
                          <div className={css.dialogbox}>
                            <div className={css.dialogheader}>
                              <button className={css.dialogclose} onClick={handleClose}>
                                ×
                              </button>
                            </div>
                            <div className={css.dialogcontent}>{selectedInfo}</div>
                          </div>
                        </div>
                      )}
                    </div> </div>
                </>
              ) : null}

              <br></br>
              {values?.bookingStartDate && isDiscountAvailable && !(isDiscountExpired) && !this.state.isDiscountApplied ? (
                <div className={css.discountTab}>
                  <Button className={css.discountButtomn}

                    type="button"
                    onClick={() => {
                      this.applyDiscount(values, discountValue, discountType, this.state.selectedPackage);
                    }}
                    disabled={isDisabled}
                  >
                    <TagOutlined /> Apply {discountType == 'percentage' ? `${discountValue}%` : `$${discountValue}`}{' '}
                    Discount
                  </Button>
                </div>
              ) : null}
              {this.state.isDiscountApplied && (!isDiscountExpired) && <div className={css.discountApplySuccess}>Discount Applied sucessfully</div>}
              {showEstimatedBreakdown ? (
                <div className={css.priceBreakdownContainer}>
                  <H6 as="h3" className={css.bookingBreakdownTitle}>
                    <FormattedMessage id="BookingTimeForm.priceBreakdownTitle" />
                  </H6>
                  <hr className={css.totalDivider} />
                  <EstimatedCustomerBreakdownMaybe
                    breakdownData={breakdownData}
                    lineItems={lineItems}
                    timeZone={timeZone}
                    currency={unitPrice.currency}
                    marketplaceName={marketplaceName}
                    processName={BOOKING_PROCESS_NAME}
                    duration={duration}
                    unitPrice={unitPrice}
                    commissions={commissions}
                    listingType={listingType}
                    distance={distance}
                    setDistance={setDistance}
                  />
                </div>
              ) : null}

              {fetchLineItemsError ? (
                <span className={css.sideBarError}>
                  <FormattedMessage id="BookingTimeForm.fetchLineItemsError" />
                </span>
              ) : null}

              {listingType == 'package' ? (
                <div className={css.submitButton}>
                  {packageBook ? (
                    <p className={css.packageValidation}>Please select atleast one package</p>
                  ) : null}
                  <PrimaryButton
                    type="submit"
                    inProgress={fetchLineItemsInProgress}
                    disabled={packageBook}
                  >
                    <FormattedMessage id="BookingTimeForm.requestToBook" />
                  </PrimaryButton>
                </div>
              ) : (
                <div className={css.submitButton}>
                  <PrimaryButton
                    type="submit"
                    inProgress={fetchLineItemsInProgress}
                    disabled={this.state.isServiceError}
                  >
                    <FormattedMessage id="BookingTimeForm.requestToBook" />
                  </PrimaryButton>
                </div>
              )}

              <p className={css.finePrint}>
                {payoutDetailsWarning ? (
                  payoutDetailsWarning
                ) : (
                  <FormattedMessage
                    id={
                      isOwnListing
                        ? 'BookingTimeForm.ownListing'
                        : 'BookingTimeForm.youWontBeChargedInfo'
                    }
                  />
                )}
              </p>
            </Form>
          );
        }}
      />
    );
  }
}

BookingTimeFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  price: null,
  isOwnListing: false,
  listingId: null,
  startDatePlaceholder: null,
  endDatePlaceholder: null,
  monthlyTimeSlots: null,
  lineItems: null,
  fetchLineItemsError: null,
};

BookingTimeFormComponent.propTypes = {
  rootClassName: string,
  className: string,

  marketplaceName: string.isRequired,
  price: propTypes.money,
  isOwnListing: bool,
  listingId: propTypes.uuid,
  monthlyTimeSlots: object,
  onFetchTimeSlots: func.isRequired,
  timeZone: string.isRequired,

  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,

  // from injectIntl
  intl: intlShape.isRequired,

  // for tests
  startDatePlaceholder: string,
  endDatePlaceholder: string,

  dayCountAvailableForBooking: number.isRequired,
};

const BookingTimeForm = compose(injectIntl)(BookingTimeFormComponent);
BookingTimeForm.displayName = 'BookingTimeForm';

export default BookingTimeForm;
